<page-heading
  [title]="'shared.settingsModule.heading' | translate"
  [description]="'shared.settingsModule.headingDescription' | translate"
/>

@if (channel) {
  <form [formGroup]="formGroup">
    <div class="row g-3 mb-0">

      <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
        <div class="card h-100">
            
          <div class="w-100 border rounded p-2 d-flex flex-column h-100">
            <div class="custom-switch">
              <input 
                type="checkbox" 
                id="activeCSATModule" 
                data-switch="success" 
                formControlName="activeCSATModule"
                tabindex="0"
              />
              <label for="activeCSATModule">
                <span class="d-block fw-bold">
                  {{ 'shared.settingsModule.csatTitle' | translate }}
                </span>
              </label>
            </div>

            @if (formGroup.get('activeCSATModule').value === true && settingsModule?.activeCSATModule) {
              <div class="flex flex-col h-full justify-start items-start mt-2 gap-2" (click)="editCSAT()">
                <div>
                  <label class="fw-medium">{{ 'shared.settingsModule.evaluationQuestion' | translate }}</label>
                  <h5 class="font-semibold text-sm">{{ settingsModule?.evaluationQuestionCSAT ?? '-' }}</h5>
                </div>
                <div>
                  <label class="fw-medium">{{ 'shared.settingsModule.responseOptions' | translate }}</label>
                  <h5 class="font-semibold text-sm">{{ settingsModule?.note1CSAT ?? '-' }}</h5>
                  <h5 class="font-semibold text-sm">{{ settingsModule?.note2CSAT ?? '-' }}</h5>
                  <h5 class="font-semibold text-sm">{{ settingsModule?.note3CSAT ?? '-' }}</h5>
                  <h5 class="font-semibold text-sm">{{ settingsModule?.note4CSAT ?? '-' }}</h5>
                  <h5 class="font-semibold text-sm">{{ settingsModule?.note5CSAT ?? '-' }}</h5>
                </div>
                <div>
                  <label class="fw-medium">{{ 'shared.settingsModule.maxWaitTimeEvaluation' | translate }}</label>
                  <h5 class="font-semibold text-sm">{{settingsModule?.noResponseTimeoutCSAT?
                    settingsModule?.noResponseTimeoutCSAT + ' ' + ('shared.settingsModule.minutesSuffix' | translate): '' }}</h5>
                </div>
                <div>
                  <label class="fw-medium">{{ 'shared.settingsModule.ignoreAfterInvalidAttempts' | translate }}</label>
                  <h5 class="font-semibold text-sm">{{ settingsModule?.amountAttemptedResponseCSAT ?? '-' }}</h5>
                </div>
                <div>
                  <label class="fw-medium">{{ 'shared.settingsModule.notifySupervisorsLowRatings' | translate }}</label>
                  <h5 class="font-semibold text-sm">{{ settingsModule?.ratingNotificationSupervisorCSAT ?? '-' }}</h5>
                </div>
                <div>
                  <label class="fw-medium">{{ 'shared.settingsModule.messageForRatingFive' | translate }}</label>
                  <h5 class="font-semibold text-sm" [innerHTML]="settingsModule?.messageSendCSAT ?? '-' "></h5>
                </div>
              </div>
            }
          </div>

        </div>
      </div>
      
      <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
        <div class="card h-100">
            
          <div class="w-100 border rounded p-2 d-flex flex-column h-100">
            <div class="custom-switch">
              <input 
                type="checkbox" 
                id="activeIAModule" 
                data-switch="success" 
                formControlName="activeIAModule"
                tabindex="0"
              />
              <label for="activeIAModule">
                <span class="d-block fw-bold">
                  {{ 'shared.settingsModule.aiTitle' | translate }}
                </span>
              </label>
            </div>

            @if (formGroup.get('activeIAModule').value === true && settingsModule?.activeIAModule) {
              <div class="w-100 d-flex flex-column p-2">
                <label class="fw-medium">{{ 'shared.settingsModule.aiAssistants' | translate }}</label>
                <mat-select
                  class="form-control"
                  formControlName="assistant"
                  [placeholder]="'shared.settingsModule.select' | translate"
                  (selectionChange)="onSelectAssistant($event)"
                >
                  <mat-option [value]="null">{{ 'shared.settingsModule.none' | translate }}</mat-option>
                  
                  @for (integration of integrations; track integration) {
                    <mat-optgroup [label]="integration.name">
                      @for (assistant of getAssistantsAndAgents(integration); track assistant) {
                        <mat-option [value]="assistant.id">
                          {{ assistant.name }}
                        </mat-option>
                      }
                    </mat-optgroup>
                  }
                </mat-select>

                <button 
                  type="button" 
                  class="btn btn-info fw-bold mt-3" 
                  (click)="openIAScheduleModal()"
                >
                  <i class="mdi mdi-clock-outline me-1"></i>
                  {{ 'shared.settingsModule.setInactivitySchedule' | translate }}
                </button>
              </div>
            }
          </div>

        </div>
      </div>

      <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
        <div class="card h-100">
          <div class="w-100 border rounded p-2 d-flex flex-column h-100">
            <div class="custom-switch">
              <input 
                type="checkbox" 
                id="activeWavoipModule" 
                data-switch="success" 
                formControlName="activeWavoipModule"
                tabindex="0"
              />
              <label for="activeWavoipModule">
                <span class="d-block fw-bold">
                  TrendVoip
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
        <div class="card h-100">
            
          <div class="w-100 border rounded p-2 d-flex flex-column h-100">
            <div class="custom-switch">
              <input 
                type="checkbox" 
                id="activeCustomerPortfolioModule" 
                data-switch="success" 
                formControlName="activeCustomerPortfolioModule"
                tabindex="0"
                (change)="onToggleCustomerPortfolioModuleChange()"
              />
              <label for="activeCustomerPortfolioModule">
                <span class="d-block fw-bold">
                  {{ 'shared.settingsModule.customerPortfolio' | translate }}
                </span>
              </label>
            </div>

            @if(isCustomerPortfolioModuleActive()) {
            <div 
              class="flex flex-col h-full justify-start items-start mt-2 gap-2" 
              (click)="editCustomerPortfolio()"
            >
              <div>
                <label class="fw-medium">{{ 'shared.settingsModule.noResponseTimeout' | translate }}</label>
                <h5 class="font-semibold text-sm cursor-pointer">
                  {{settingsModule?.noResponseTimeoutCustomerPortfolio?
                  settingsModule?.noResponseTimeoutCustomerPortfolio + ' ' + ('shared.settingsModule.minutesSuffix' | translate): '' }}
                </h5>
              </div>
            </div>
            }

          </div>

        </div>
      </div>

    </div>
  </form>

  <hr class="mt-2" />
  <div class="row">
    <div class="col-12 d-flex justify-content-end">
      @if (isAdmin()) {
        <button class="btn btn-info fw-bold" [disabled]="loading" cdkFocusInitial (click)="onConfirmClick()">
          {{ !loading ? ('shared.settingsModule.save' | translate) : "" }}
          @if (loading) {
            <mat-spinner [diameter]="15" [color]="'accent'" mode="indeterminate" />
          }
        </button>
      }
    </div>
  </div>
}
